import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

import { Variable, VariableSummary } from '@mtna/pojo-consumer-ui';

/**
 * Filters Variables down to those that can be used as dimensions.
 */
@Pipe({
  name: 'rdsIsDimension',
})
export class IsDimensionPipe implements PipeTransform {
  transform(variables: Array<Variable | VariableSummary> | null): Array<Variable | VariableSummary> {
    if (!variables) {
      return [];
    }
    return variables.filter((v) => v.isDimension);
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [IsDimensionPipe],
  declarations: [IsDimensionPipe],
})
export class RdsIsDimensionPipeModule {}
